import React from 'react';
import _ from 'lodash';
import { useBiSessionContext } from '@components/Contexts/BiSessionContext';
import Header from '@components/Header';
import { PAGE_NAMES } from '@components/Hooks/useMarketplaceHeaderBi';
import CommunityNavSubHeader from '@components/CommunityNavSubHeader';
import { useStudioCommunityHeader } from '@components/Hooks/ExperimentHooks/useStudioCommunityHeader';

interface Props {
  isMobileView?: boolean;
}

const TemplateGalleryPageHeader = ({ isMobileView }: Props) => {
  const { sessionId } = useBiSessionContext();
  const { isStudioCommunityHeaderEnabled } = useStudioCommunityHeader();

  if (isStudioCommunityHeaderEnabled) {
    return <CommunityNavSubHeader isMobile={isMobileView} />;
  }

  return (
    <Header
      onClick={() => {}}
      pageName={PAGE_NAMES.templates}
      sessionId={sessionId}
    />
  );
};

export default TemplateGalleryPageHeader;
